module.exports = __webpack_public_path__ + "img/1006.5966688a.jpg";